import {sortShiftPropertiesPrimaryFirst} from "./helpers";
import {Shift, ShiftType} from "../types";

export type ShiftPropertyPlacement = {
  id: number;
  name: string;
};

export function getShiftPropertyPlacements(shift: Shift): ShiftPropertyPlacement[] {
  if (!shift.properties?.length) {
    return [];
  }

  const sorted = sortShiftPropertiesPrimaryFirst(shift.properties);

  if (shift.type === ShiftType.PATROL) {
    return sorted.map((p) => ({
      id: p.property.id,
      name: p.property.name,
    }));
  }

  const primary =
    sorted.find((p) => p.assignment_type === "primary") ?? sorted[0];

  return primary
    ? [
        {
          id: primary.property.id,
          name: primary.property.name,
        },
      ]
    : [];
}

export type ShiftBadgeItem = {key: string; name: string};

/**
 * Display badges for shift lists/calendar. Patrol shifts NEVER show property
 * badges: a routed patrol shift shows a single route-name badge; a route-less
 * patrol shift (legacy, or list payload missing `patrol_route`) shows nothing.
 * Only non-patrol shifts fall back to per-property badges.
 */
export function getShiftBadgeItems(shift: Shift): ShiftBadgeItem[] {
  if (shift.type === ShiftType.PATROL) {
    return shift.patrol_route
      ? [
          {
            key: `route-${shift.patrol_route.patrol_route_id}`,
            name: shift.patrol_route.name,
          },
        ]
      : [];
  }
  return (shift.properties ?? []).map((p) => ({
    key: `${shift.shift_id}-${p.property.id}`,
    name: p.property.name,
  }));
}
